import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { useStores } from '../hooks/use-stores';

const SSO = observer(() => {
    const { brandingStore } = useStores();

    useEffect(() => {
        console.log(brandingStore.loginUrl);
        if (brandingStore.loginUrl) {
            window.location = brandingStore.loginUrl;
        }
    }, [brandingStore.loginUrl]);

    return brandingStore.loginUrl ? null : <Navigate to="/" />;
});

export default SSO;
